import React from 'react';
import { Reveal } from '../ui/Reveal';
import { STATS } from '../../data/content';
import { useLanguage } from '../../i18n/LanguageContext';
export function StatsBand() {
  const {
    lang,
    t
  } = useLanguage();
  return <section className="w-full bg-navy py-20" aria-label={t.stats.label} data-id="element-179" data-mp="1er7oqffawpey">
      <div className="mx-auto max-w-container px-6" data-id="element-180" data-mp="1ar6wnrza4fpf">
        <dl className="grid grid-cols-2 gap-10 lg:grid-cols-4" data-id="element-181" data-mp="1aqdvr7n04kf7">
          {STATS.map((stat, i) => <Reveal key={stat.label.en} delay={i * 0.08} data-id="element-182" data-mp="15tnj6uaeo6yj" data-mpi={i}>
              <div className="text-center" data-id="element-183" data-mp="10zt2lzq3k83o">
                <dt className="sr-only" data-id="element-184" data-mp="10yri74n6y99a">{stat.label[lang]}</dt>
                <dd data-id="element-185" data-mp="w2j4lvon6o48">
                  <span className="block font-display text-4xl font-medium text-gold-light lg:text-5xl" data-id="element-186" data-mp="w20z08g3axjn">
                    {stat.value}
                  </span>
                  <span className="mx-auto mt-4 block h-px w-10 bg-white/20" aria-hidden="true" data-id="element-187" data-mp="n1covotthhc1" />
                  <span className="mt-4 block text-[11px] uppercase tracking-[0.16em] text-navy-100/70" data-id="element-188" data-mp="i1qb9ea2tz2p">
                    {stat.label[lang]}
                  </span>
                </dd>
              </div>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}